<div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex="96" fxFlex.xs="100">
        <app-create-role [role]="data.role" [isEdit]="true" (closeDialog)="closeDialog()"></app-create-role>
    </div>
</div>